import type { EventCapturer } from '#src/analytics/analytics_event.ts';
import { GroupNameResetEvent } from '#src/groups/analytics/group_analytics_events.ts';
import resetNameImage from '#src/pages/group/leave_name_card/assets/reset_name.webp';
import { DisplayParticipantName } from '#src/ui/presentation/display_participant_name.tsx';
import { Button } from '@packages/ui/base/button/button';
import { Card } from '@packages/ui/base/card/card';

export interface LeaveNameCardProps {
  captureEvent: EventCapturer;
  participantName: string;
  /** Forgets the name on this device only. Never changes the match or the wishlist. */
  onLeave: () => void;
  onCancel: () => void;
}

export const LeaveNameCard = ({
  captureEvent,
  participantName,
  onLeave,
  onCancel,
}: LeaveNameCardProps) => {
  return (
    <Card
      className="flex max-h-full max-w-xl flex-col overflow-hidden"
      bannerImage={resetNameImage}
      bannerImageAlt="Warning icon with an open lock"
    >
      <div
        data-testid="leave-name-step"
        className="animate-in fade-in flex min-h-0 flex-1 flex-col"
      >
        <h1 className="mb-4 text-xl font-bold">You&apos;re about to reset your name choice</h1>

        <p className="text-muted-foreground mb-6">
          You may need to wait a short time before choosing another name. Your match and wishlist
          will not change.
        </p>

        <div className="flex flex-col gap-3 sm:flex-row-reverse">
          <Button
            variant="destructive"
            className="min-w-0 sm:flex-1"
            onClick={() => {
              captureEvent(GroupNameResetEvent, {});
              onLeave();
            }}
            type="button"
          >
            <span className="truncate">
              I am not <DisplayParticipantName name={participantName} />
            </span>
          </Button>
          <Button variant="secondary" className="sm:flex-none" onClick={onCancel} type="button">
            <span>Go back</span>
          </Button>
        </div>
      </div>
    </Card>
  );
};
